/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Price_Cap_DescriptionInputs */

const en_admin_resource_form_price_cap_description = /** @type {(inputs: Admin_Resource_Form_Price_Cap_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop charging once bookings reach a set duration`)
};

const de_admin_resource_form_price_cap_description = /** @type {(inputs: Admin_Resource_Form_Price_Cap_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchungspreis nur bis zu einer bestimmten Dauer berechnen, und danach fester Preis.`)
};

const es_admin_resource_form_price_cap_description = /** @type {(inputs: Admin_Resource_Form_Price_Cap_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dejar de cargar una vez que las reservas alcancen una duración establecida`)
};

const fr_admin_resource_form_price_cap_description = /** @type {(inputs: Admin_Resource_Form_Price_Cap_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrêter la charge lorsque les réservations atteignent une durée déterminée`)
};

/** @type {(inputs: Admin_Resource_Form_Price_Cap_DescriptionInputs) => LocalizedString} */
const it_admin_resource_form_price_cap_description = en_admin_resource_form_price_cap_description;

/** @type {(inputs: Admin_Resource_Form_Price_Cap_DescriptionInputs) => LocalizedString} */
const pt_br2_admin_resource_form_price_cap_description = en_admin_resource_form_price_cap_description;

/** @type {(inputs: Admin_Resource_Form_Price_Cap_DescriptionInputs) => LocalizedString} */
const pl_admin_resource_form_price_cap_description = en_admin_resource_form_price_cap_description;

/** @type {(inputs: Admin_Resource_Form_Price_Cap_DescriptionInputs) => LocalizedString} */
const hu_admin_resource_form_price_cap_description = en_admin_resource_form_price_cap_description;

/** @type {(inputs: Admin_Resource_Form_Price_Cap_DescriptionInputs) => LocalizedString} */
const ro_admin_resource_form_price_cap_description = en_admin_resource_form_price_cap_description;

/**
* | output |
* | --- |
* | "Stop charging once bookings reach a set duration" |
*
* @param {Admin_Resource_Form_Price_Cap_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_price_cap_description = /** @type {((inputs?: Admin_Resource_Form_Price_Cap_DescriptionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Price_Cap_DescriptionInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_price_cap_description(inputs)
	if (locale === "de") return de_admin_resource_form_price_cap_description(inputs)
	if (locale === "es") return es_admin_resource_form_price_cap_description(inputs)
	if (locale === "fr") return fr_admin_resource_form_price_cap_description(inputs)
	if (locale === "it") return it_admin_resource_form_price_cap_description(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_price_cap_description(inputs)
	if (locale === "pl") return pl_admin_resource_form_price_cap_description(inputs)
	if (locale === "hu") return hu_admin_resource_form_price_cap_description(inputs)
	return ro_admin_resource_form_price_cap_description(inputs)
});
export { admin_resource_form_price_cap_description as "admin.resource_form.price_cap_description" }